// extracted by mini-css-extract-plugin
export var lightMode = "_redotech-redo-web-src-theme-component-colors-light-light-mode";